import { NavLink } from "react-router";

const tabs = [
  { to: "/", label: "회의", icon: "📋" },
  { to: "/upload", label: "업로드", icon: "⬆️" },
  { to: "/settings", label: "설정", icon: "⚙️" },
];

export function TabBar() {
  return (
    <nav className="fixed bottom-0 inset-x-0 bg-slate-900/95 backdrop-blur border-t border-slate-800 safe-bottom">
      <ul className="flex">
        {tabs.map((t) => (
          <li key={t.to} className="flex-1">
            <NavLink
              to={t.to}
              end={t.to === "/"}
              className={({ isActive }) => `tap flex flex-col items-center justify-center h-14 text-xs ${isActive ? "text-indigo-300" : "text-slate-400"}`}
            >
              <span className="text-lg leading-none mb-1">{t.icon}</span>
              {t.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
